const ConfirmationMsg = () => {
const name = localStorage.getItem('name') || "";
const msg= `You are in queue ${name}, please hold tight one of our representatives will reach out to you here shortly. 
          In the meantime, if you have any questions you'd like to ask, feel free to let me know I'm here to help!`
          
  return (
    <>
      <div className="h-full w-full">
        <h1 className="text-[14px] text-[#2B2F38] font-normal">
          {msg}
        </h1>
      </div>
    </>
  );
};

export default ConfirmationMsg;
